<script setup lang="ts">
/**
 * GETリクエストでの、APIローディング表示コンテンツ。
 */
import { useSlots } from "vue";
import { ApiGetLoadStatus, ApiGetLoadStatusType } from "@/modules/types/apiLoadStatusType";
import ApiErrorDisplay from "./ApiErrorDisplay.vue";
import ApiLoadingDisplay from "./ApiLoadingDisplay.vue";

interface Props {
	/**
	 * APIステータス。
	 */
	status: ApiGetLoadStatusType;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();

const slots = useSlots();
/**
 * エラーのslot内容があるかどうか。
 */
const isExistErrorSlot = (): boolean => {
	if (!slots.error) {
		return false;
	}
	return true;
};
</script>

<template>
	<div class="revico-api-master">
		<!-- APIローディング状態に表示するコンテンツ -->
		<slot name="loading" v-if="props.status === ApiGetLoadStatus.loading">
			<api-loading-display />
		</slot>

		<!-- API成功時に表示するコンテンツ -->
		<slot v-else-if="status === ApiGetLoadStatus.success" name="contents"></slot>

		<!-- API失敗時に表示するコンテンツ -->
		<api-error-display v-else-if="status === ApiGetLoadStatus.error && !isExistErrorSlot()" />
		<slot name="error" v-if="status === ApiGetLoadStatus.error"></slot>
	</div>
</template>
